const urlConfig = {
  url: 'https://lanzhouapi.shyunhua.com/',
  imgUrl:'https://file.shyunhua.com/',
  file: {
    up: 'https://lanzhouapi.shyunhua.com/file/upload/',
    show: 'https://file.shyunhua.com/',
  },
};
window.urlConfig = urlConfig;
export default urlConfig;